const CHUNK_RELOAD_SESSION_KEY = 'app-stale-chunk-reload';

export const isChunkLoadError = (error) => {
	if (!error) return false;
	const message = typeof error?.message === 'string' ? error.message : String(error);
	return (
		error?.name === 'ChunkLoadError' ||
		/Loading chunk [\d]+ failed/i.test(message) ||
		/ChunkLoadError/i.test(message) ||
		/Failed to fetch dynamically imported module/i.test(message)
	);
};

/** 发版后旧包引用已删除 chunk 时，自动刷新一次以拉取新 index/main。 */
export const reloadOnceForStaleChunk = () => {
	if (sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY)) return false;
	sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, '1');
	window.location.reload();
	return true;
};

export const clearStaleChunkReloadFlag = () => {
	sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
};
